import type { Logger } from '@vp/ubik-logging'

import { fetchWithRetry, isNetworkError } from './fetchWithRetry'
import { REQUESTOR } from '../utils/constants'

const baseUrl = 'https://cart.large-assortment.vpsvc.com/v1'

// Default timeout of 10 seconds for cart requests
const DEFAULT_TIMEOUT_MS = 10000

export const upsertCart = async (cartTenant: string, workId: string, culture: string, authorizationHeader: string, logger: Logger): Promise<void> => {
  const params = new URLSearchParams({
    locale: culture,
    tenant: cartTenant,
    requestor: REQUESTOR,
  })
  const url = `${baseUrl}/upsert/${workId}?${params.toString()}`

  try {
    await fetchWithRetry(
      url,
      {
        method: 'POST',
        headers: {
          Authorization: authorizationHeader,
        },
        signal: AbortSignal.timeout(DEFAULT_TIMEOUT_MS),
      },
      1,
      logger,
      { workId, culture },
    )
  } catch (error) {
    logger.error('Upserting customer cart failed', error as Error, {
      workId,
      culture,
      url,
      isNetworkError: isNetworkError(error),
      isTimeout: error instanceof DOMException && error.name === 'AbortError',
    })
    throw error
  }
}

export const upsertCartMultiWork = async (
  cartTenant: string,
  workIds: string[],
  culture: string,
  authorizationHeader: string,
  logger: Logger,
): Promise<void> => {
  const params = new URLSearchParams({
    workIds: workIds.join(','),
    locale: culture,
    requestor: REQUESTOR,
  })
  const url = `${baseUrl}/${cartTenant}/upsert/work?${params.toString()}`

  try {
    await fetchWithRetry(
      url,
      {
        method: 'POST',
        headers: {
          Authorization: authorizationHeader,
        },
        signal: AbortSignal.timeout(DEFAULT_TIMEOUT_MS),
      },
      1,
      logger,
      { workIds: workIds.join(','), culture },
    )
  } catch (error) {
    logger.error('Upserting customer cart (multi-work) failed', error as Error, {
      workIds: workIds.join(','),
      culture,
      url,
      isNetworkError: isNetworkError(error),
      isTimeout: error instanceof DOMException && error.name === 'AbortError',
    })
    throw error
  }
}
